import { render, staticRenderFns } from "./carRecordList.vue?vue&type=template&id=724d5cc1&"
import script from "./carRecordList.vue?vue&type=script&lang=js&"
export * from "./carRecordList.vue?vue&type=script&lang=js&"
import style0 from "./carRecordList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports